
import { updateHistoryEntry } from "../../api/historyService";

export const useUpdateHistoryEntry = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateHistoryEntry(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update history entry:", error);
        throw error;
    }
  };

  return { update };
};